// extracted by mini-css-extract-plugin
export default {"dayContainer":"styles_dayContainer__Us0Yt","dateHeader":"styles_dateHeader__swmM2","frame":"styles_frame__u149o"};